import React from 'react'
import {Layer, Rect} from 'react-konva'
import {FRAGMENT_DETECTION} from '../../../constant/fragmentDetection'

/**
 * FragmentHighlight - Overlays bounding boxes on detected fragments
 * @param {Object} props
 * @param {Array} props.fragments - Array of fragment objects
 * @param {boolean} props.visible - Whether highlights are visible
 */
const FragmentHighlight = ({fragments = [], visible = true}) => {
    if (!visible || !fragments || fragments.length === 0) {
        return null
    }

    // Determine color based on fragment count
    const getColor = () => {
        if (fragments.length > 10) {
            return FRAGMENT_DETECTION.HIGHLIGHT_COLORS.error
        } else if (fragments.length > 5) {
            return FRAGMENT_DETECTION.HIGHLIGHT_COLORS.warning
        }
        return FRAGMENT_DETECTION.HIGHLIGHT_COLORS.info
    }

    const highlightColor = getColor()

    return (
        <Layer listening={false}>
            {fragments.map((fragment, index) => (
                <Rect
                    key={fragment.id || index}
                    x={fragment.x}
                    y={fragment.y}
                    width={fragment.width}
                    height={fragment.height}
                    stroke={highlightColor}
                    strokeWidth={2}
                    fill={`${highlightColor}20`} // 20 = ~12% opacity in hex
                    dash={[5, 5]}
                    listening={false}
                />
            ))}
        </Layer>
    )
}

export default FragmentHighlight

